import { Box, BoxProps, Stack, styled } from "@mui/material";

import Logomark from "@app/common/assets/ReadLogomark.png";

import PlayClip, { PlayClipProps } from "../PlayClip";

interface VideoPreviewProps {
  videoSrc: string;
  duration: number;
  /** Unit of duration. Defaults to seconds */
  unit?: PlayClipProps["unit"];
  playing?: boolean;
  onClick?: () => void;
}

interface ImageBoxProps extends BoxProps {
  src: string;
}

const StyledImageBox = styled(({ ...props }: ImageBoxProps) => (
  <Box {...props} />
))(({ theme }) => ({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  borderRadius: "2px",
  "&::before": {
    // Fallback if there's some error showing the thumbnail
    borderRadius: "2px",
    content: "' '",
    display: "block",
    position: "absolute",
    height: "100%",
    width: "100px",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "30px",
    objectFit: "cover",
    backgroundColor: theme.palette.shades.neutral[900],
    backgroundImage: `url("${Logomark}")`,
  },
}));

const VideoPreview = ({
  videoSrc,
  duration,
  unit,
  playing = false,
  onClick,
}: VideoPreviewProps) => {
  return (
    <Stack
      sx={{
        borderRadius: "2px",
        minWidth: "100px",
        width: "100px",
        height: "60px",
        backgroundColor: "shades.neutral.100",
        position: "relative",
      }}
      onClick={onClick}
    >
      <StyledImageBox component="img" src={videoSrc} />
      {duration > 0 && (
        <PlayClip
          duration={duration}
          playing={playing}
          sx={{ position: "absolute", bottom: "3px", right: "9px" }}
          unit={unit}
        />
      )}
    </Stack>
  );
};

export default VideoPreview;
